import { HttpError } from "react-admin";

import { errorMessages, settings } from "app";

import { LEGACY, MIXED, PASCAL } from "./dataProvider.types";
import { getOptions } from "./dataProvider.getOptions";
import { SessionExpiredDialogService } from "services/SessionExpiredDialogService";

export const getProviderType = params => {
  let result = MIXED;

  if (!!params?.meta?.legacy_provider) {
    return LEGACY;
  }

  if (!!params?.meta?.mixed_provider) {
    return MIXED;
  }
  if (!!params?.meta?.pascal_provider) {
    return PASCAL;
  }
  if (settings.dataProviderVersion) {
    return settings.dataProviderVersion;
  }

  return result;
};

export const getListData = ({ response, params }) => {
  let data;
  let totalItems;

  switch (getProviderType(params)) {
    case LEGACY:
      data = response.json;
      totalItems = parseInt(response.headers.get("x-total-count"));
      break;
    case MIXED:
      data = response.json.items || response.json;
      totalItems = response.json.total_items || response.json.totalItems || response.json.length;
      break;
    case PASCAL:
      data = response.json.Items || response.json;
      totalItems = response.json.TotalItems;
      break;
    default:
      throw new Error("Not implemented operation");
  }

  if (data?.some(x => x.id === undefined)) {
    data = data.map((x, i) => ({
      id: x.Id ?? i,
      ...x,
    }));
  }

  return {
    data,
    total: totalItems,
  };
};

export const createResponse = response => {
  const { json } = response;

  let resp = { data: { id: json?.objectId || json?.id, props: json } };
  return resp;
};

export const fetchJson = async ({ url, method, data, params }) => {
  const options = getOptions(method, data, params);

  return fetch(url, options)
    .then(response =>
      response.text().then(text => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text,
      })),
    )
    .then(({ status, statusText, headers, body, response }) => {
      let json;
      try {
        json = JSON.parse(body);
      } catch (e) {
        // not json, no big deal
      }
      if (status === 401) {
        SessionExpiredDialogService.open({ isOpen: true });
      }

      if (status < 200 || status >= 300) {
        const errorCode = json?.errorCode || json?.ErrorCode;
        if (errorCode) {
          let errorResponse;

          if (json?.properties?.length > 0) {
            return Promise.reject(json);
          } else {
            if (errorMessages[errorCode]) {
              errorResponse = errorMessages[errorCode];
            } else {
              if (process.env.NODE_ENV === "development") {
                errorResponse = errorCode;
              } else {
                errorResponse = errorMessages.default;
              }
            }

            return Promise.reject(new HttpError(errorResponse, status, json));
          }
        }

        return Promise.reject(new HttpError((json && json.message) || statusText, status, json));
      }
      return Promise.resolve({ status, headers, body, json });
    });
};
